// extracted by mini-css-extract-plugin
export default {"wrapper":"OfferActions_wrapper__tUQEj"};